import { Menu } from '../util/constants'

const state = {
  activeMenuIndex: Menu.Home,
  userActiveMenuIndex: Menu.User.MyProfile,
  messageNumber: 0
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js